var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { useConfig } from '@browsing/config';
import { useConsentManager } from '@browsing/tracking';
import { getCookie } from '@browsing/utils';
import { tracker } from '../tracking';
import { COOKIE_BRAZE } from './helpers';
import { loadBrazeSDK } from './scripts';
export var mapLoungeGenderToBrazeGender = function (gender) {
    switch (gender) {
        case 'male':
            return 'm';
        case 'female':
            return 'f';
        default:
            return 'u';
    }
};
export var useInitializeAndOpenBrazeSession = function (hashedCustomerNumber, gender, firstName) {
    var hasConsent = useConsentManager('braze_lounge')[0];
    var config = useConfig();
    var localeCode = config.localeCode.replace('_', '-');
    var _a = useState(false), isBrazeInitialised = _a[0], setIsBrazeInitialised = _a[1];
    var _b = useState(false), areCardsReady = _b[0], setAreCardsReady = _b[1];
    var _c = useState(null), cardList = _c[0], setCardList = _c[1];
    var _d = useState(null), cardMethodsFromBraze = _d[0], setCardMethodsFromBraze = _d[1];
    useEffect(function () {
        var isBrazeAllowedOnCookie = getCookie(COOKIE_BRAZE) === 'true';
        if (hashedCustomerNumber &&
            (((config === null || config === void 0 ? void 0 : config.isEnabled('braze')) && hasConsent && typeof config.braze !== 'undefined') ||
                isBrazeAllowedOnCookie)) {
            var initiateBraze = function () { return __awaiter(void 0, void 0, void 0, function () {
                var _a, initialize, openSession, getUser, changeUser, subscribeToContentCardsUpdates, requestContentCardsRefresh, logContentCardImpressions, logCardDismissal, logCardClick;
                var _b, _c, _d, _e, _f, _g;
                return __generator(this, function (_h) {
                    switch (_h.label) {
                        case 0: return [4 /*yield*/, loadBrazeSDK()];
                        case 1:
                            _a = _h.sent(), initialize = _a.initialize, openSession = _a.openSession, getUser = _a.getUser, changeUser = _a.changeUser, subscribeToContentCardsUpdates = _a.subscribeToContentCardsUpdates, requestContentCardsRefresh = _a.requestContentCardsRefresh, logContentCardImpressions = _a.logContentCardImpressions, logCardDismissal = _a.logCardDismissal, logCardClick = _a.logCardClick;
                            setCardMethodsFromBraze({
                                logContentCardImpressions: logContentCardImpressions,
                                logCardDismissal: logCardDismissal,
                                logCardClick: logCardClick,
                            });
                            initialize(((_b = config.braze) === null || _b === void 0 ? void 0 : _b.apiKey) || '', {
                                baseUrl: ((_c = config.braze) === null || _c === void 0 ? void 0 : _c.baseUrl) || '',
                                enableLogging: isBrazeAllowedOnCookie || ((_d = config.braze) === null || _d === void 0 ? void 0 : _d.enableLogging),
                                enableHtmlInAppMessages: true,
                                allowUserSuppliedJavascript: true,
                            });
                            subscribeToContentCardsUpdates(function (cards) {
                                var cardListInternal = cards.cards;
                                setAreCardsReady(true);
                                // @ts-expect-error
                                var cardListWithoutClicked = cardListInternal.filter(function (card) { return !card.clicked; });
                                setCardList(cardListWithoutClicked);
                            });
                            requestContentCardsRefresh();
                            openSession();
                            changeUser(hashedCustomerNumber);
                            if (gender) {
                                (_e = getUser()) === null || _e === void 0 ? void 0 : _e.setGender(mapLoungeGenderToBrazeGender(gender));
                            }
                            if (localeCode) {
                                (_f = getUser()) === null || _f === void 0 ? void 0 : _f.setCustomUserAttribute('web_last_locale', localeCode);
                            }
                            if (firstName) {
                                (_g = getUser()) === null || _g === void 0 ? void 0 : _g.setFirstName(firstName);
                            }
                            tracker.track('braze_web_initiated', { customerHash: hashedCustomerNumber });
                            setIsBrazeInitialised(true);
                            return [2 /*return*/];
                    }
                });
            }); };
            initiateBraze();
        }
    }, [config, hasConsent, gender, hashedCustomerNumber, firstName, localeCode]);
    return { isBrazeInitialised: isBrazeInitialised, areCardsReady: areCardsReady, cardList: cardList, cardMethodsFromBraze: cardMethodsFromBraze };
};
